import React, { createContext, useContext, useState, useCallback } from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

const ToastContext = createContext(null);
export const useToast = () => useContext(ToastContext);

let id = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const add = useCallback((message, type = 'success') => {
    const tid = ++id;
    setToasts(t => [...t, { id: tid, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== tid)), 4000);
  }, []);

  const remove = (tid) => setToasts(t => t.filter(x => x.id !== tid));

  const icons = {
    success: <CheckCircle size={18} />,
    error: <XCircle size={18} />,
    warning: <AlertCircle size={18} />,
  };
  const colors = {
    success: '#10B981',
    error: '#EF4444',
    warning: '#F59E0B',
  };

  return (
    <ToastContext.Provider value={add}>
      {children}
      <div style={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
        display: 'flex', flexDirection: 'column', gap: 10,
        maxWidth: 'calc(100vw - 48px)',
      }}>
        {toasts.map(t => (
          <div key={t.id} style={{
            display: 'flex', alignItems: 'center', gap: 12,
            background: '#0F172A',
            color: '#fff',
            padding: '14px 18px',
            borderRadius: 14,
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.25)',
            minWidth: 280,
            maxWidth: 400,
            fontSize: 13,
            fontWeight: 500,
            borderLeft: `4px solid ${colors[t.type]}`,
            animation: 'slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            backdropFilter: 'blur(10px)',
          }}>
            <span style={{ color: colors[t.type], flexShrink: 0, display: 'flex' }}>{icons[t.type]}</span>
            <span style={{ flex: 1, lineHeight: 1.4 }}>{t.message}</span>
            <button onClick={() => remove(t.id)} style={{
              background: 'none', border: 'none', color: '#94A3B8',
              cursor: 'pointer', display: 'flex', padding: 2,
              borderRadius: 4, transition: 'color 0.15s',
            }}
              onMouseEnter={e => e.currentTarget.style.color = '#fff'}
              onMouseLeave={e => e.currentTarget.style.color = '#94A3B8'}>
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
